import { ALL_CHART_TYPES } from "constants/chart.constants";
import { createMergeWithDefaults } from "entities/utils";
import { RateTimeChartRequestType, RateTimeChartSettings } from "types";

import { BASE_RATE_CHART_SETTINGS, BASE_RATE_REQUEST } from "./baseRateRequest";

export const DEFAULT_RATE_TIME_CHART_SETTINGS: Partial<RateTimeChartSettings> = {
  ...BASE_RATE_CHART_SETTINGS,
  chartType: ALL_CHART_TYPES.RateTime.id,
  pressureChartSettings: {
    product: "Oil",
    productivityIndex: false
  }
};

export const DEFAULT_RATE_TIME_REQUEST: Partial<RateTimeChartRequestType> = {
  ...BASE_RATE_REQUEST,
  chartSetting: DEFAULT_RATE_TIME_CHART_SETTINGS as RateTimeChartSettings
};

export const generateRateTimeRequestBody = createMergeWithDefaults(
  DEFAULT_RATE_TIME_REQUEST
);
